// @ts-nocheck

import { CashoutActionTypes } from '../types/actions/cashout';

export const cashout = (id, expectedValue, cashoutAmount = undefined) => ({
  type: cashoutAmount !== undefined ? CashoutActionTypes.CASHOUT_PARTIAL : CashoutActionTypes.CASHOUT_TOTAL,
  payload: {
    id,
    expectedValue,
    cashoutAmount,
  },
});

export const cashoutEnhanced = () => ({
  type: CashoutActionTypes.CASHOUT_ENHANCED,
});

export const cashoutEnhance = (id) => ({
  type: CashoutActionTypes.CASHOUT_ENHANCE,
  payload: {
    id,
  },
});

export const cashoutRequest = (id) => ({
  type: CashoutActionTypes.CASHOUT_REQUEST,
  payload: {
    id,
  },
});

export const cashoutFail = (id, error) => ({
  type: CashoutActionTypes.CASHOUT_FAIL,
  payload: {
    id,
    error,
  },
});

export const cashoutSuccess = (id) => ({
  type: CashoutActionTypes.CASHOUT_SUCCESS,
  payload: {
    id,
  },
});
